import { ActionMessage } from 'satcheljs';
import { LazyImport, LazyModule } from 'owa-bundling-light';
import { networkFailureHandler } from './networkFailureHandler';

/**
 * wraps the module in try/catch and shows a toast with network
 * error in case of lazy load failure
 * telemetry of network failure is handled internally by LazyImport
 *
 * @param lazyImport the action for which error handling is needed
 * @param lazyImportArgs arguments for the lazy function/action
 * @param errorMessage error string to show the user
 */
export function lazyImportWithErrorHandler<TArgs extends any[], TModule extends LazyModule<any>>(
    lazyImport: LazyImport<(...args: TArgs) => ActionMessage, TModule>
) {
    return async function (...lazyImportArgs: TArgs) {
        lazyImport
            .import()
            .then(downloadedAction => downloadedAction(...lazyImportArgs))
            .catch(networkFailureHandler);
    };
}
